import { type TopAsset, TopAssetTypes } from '@carboncopyco/types';
import { commonTypeFilterOptions } from './consts';

export const getTypeFilterOptionsByAvailableAssets = (assets: TopAsset[]) => {
  const availableAssetTypes = Object.values(TopAssetTypes).filter((type) =>
    assets.some((asset) => asset.assetType === type)
  );

  return commonTypeFilterOptions.map((option) => ({
    ...option,
    disabled: !Object.values(availableAssetTypes).includes(
      option.id as TopAssetTypes
    ),
  }));
};
